import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { RESCHEDULE_LABELS } from 'features/request-update/constants';

const ReviewRescheduleTC = ({ eventReschedule }) => {
  const { t } = useTranslation();
  return (
    <div className="review-section">
      <div className="subtitle">{t('requestUpdate.rescheduleTCModal.rescheduleLabel')}</div>
      {Object.entries(RESCHEDULE_LABELS).map(
        ([key, value]) =>
          eventReschedule[key] && (
            <div className="is-updated" key={key}>
              <div className="fw-bold">{t(RESCHEDULE_LABELS[key])}</div>
              <div className="pre-wrap">{eventReschedule[key]}</div>
            </div>
          )
      )}
    </div>
  );
};

ReviewRescheduleTC.propTypes = {
  eventReschedule: PropTypes.shape({}).isRequired,
};

export default ReviewRescheduleTC;
